class CategoryPanels extends HTMLElement {
  connectedCallback() {
    this.isTouch = window.matchMedia('(hover: none)').matches;
    if (!this.isTouch) return;

    this.items = Array.from(this.querySelectorAll('.category-panels__item'));
    this.addEventListener('click', this.onClick.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  onClick(event) {
    const item = event.target.closest('.category-panels__item');
    if (!item) return;

    if (!item.classList.contains('is-active')) {
      event.preventDefault();
      this.items.forEach((i) => i.classList.remove('is-active'));
      item.classList.add('is-active');
    }
  }

  onDocumentClick(event) {
    if (this.contains(event.target)) return;
    this.items.forEach((i) => i.classList.remove('is-active'));
  }
}

customElements.define('category-panels', CategoryPanels);
